var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.loading || _vm.disabled,"loading":_vm.loading,"color":_vm.color,"block":_vm.block,"rounded":_vm.rounded,"icon":_vm.icon,"large":_vm.large,"depressed":"","outlined":""},on:{"click":function($event){return _vm.$emit("click")}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }